"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setValue = setValue;
exports.deleteValue = deleteValue;
exports.DISABLE_SOCKET = exports.PORTAL_NAME = exports.ACTIVE_INDEX_NAME = exports.ACTIVE_INDEX = exports.PROJECT_ID = exports.ES_HOST = exports.ARRANGER_API = void 0;

function getValue(key, defaultValue) {
  return process.env["STORYBOOK_".concat(key)] || process.env["REACT_APP_".concat(key)] || localStorage[key] || defaultValue;
}

function setValue(key, value) {
  localStorage[key] = value;
}

function deleteValue(key) {
  delete localStorage[key];
}

var ARRANGER_API = getValue('ARRANGER_API', 'http://localhost:5050');
exports.ARRANGER_API = ARRANGER_API;
var ES_HOST = getValue('ES_HOST', 'http://localhost:9200');
exports.ES_HOST = ES_HOST;
var PROJECT_ID = getValue('PROJECT_ID', null);
exports.PROJECT_ID = PROJECT_ID;
var ACTIVE_INDEX = getValue('ACTIVE_INDEX', null);
exports.ACTIVE_INDEX = ACTIVE_INDEX;
var ACTIVE_INDEX_NAME = getValue('ACTIVE_INDEX_NAME', '');
exports.ACTIVE_INDEX_NAME = ACTIVE_INDEX_NAME;
var PORTAL_NAME = getValue('PORTAL_NAME', 'Data Portal');
exports.PORTAL_NAME = PORTAL_NAME;
var DISABLE_SOCKET = getValue('DISABLE_SOCKET', 'false') === 'true';
exports.DISABLE_SOCKET = DISABLE_SOCKET;